/** @format */

import { AiOutlineReload } from "@react-icons/all-files/ai/AiOutlineReload";
import React from "react";
import "./Myprofile.css";

const Spinner = () => {
  return <AiOutlineReload className="reloadBL" />;
};
export default Spinner;
